<template>
  <v-row no-gutters fill-height>
    <!-- left content -->
    <v-col sm="12" md="8" class="left-content">
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="ma-4">
          <div>
            <img
              class="official-logo text-center"
              alt="Fondo EST"
              src="../assets/images/official-logo.png"
            />
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="ma-4">
          <component :is="componentId + '-msg'"></component>
        </v-col>
      </v-row>
    </v-col>
    <!-- right content -->
    <v-col sm="12" md="4" class="right-content">
      <v-container class="mx-auto pa-0">
        <component :is="componentId + '-form'"></component>
      </v-container>
    </v-col>
    <!-- modal dialogs -->
    <error-dialog></error-dialog>
    <success-dialog></success-dialog>
    <loading-dialog></loading-dialog>
  </v-row>
</template>

<script>
import FirstLogin from "../components/Homepage/FirstLogin";
import FirstLoginMsgPanel from "../components/Homepage/FirstLoginMsgPanel";
import Login from "../components/Homepage/Login";
import LoginMsgPanel from "../components/Homepage/LoginMsgPanel";
import NewPassword from "../components/Homepage/NewPassword";
import NewPasswordMsgPanel from "../components/Homepage/NewPasswordMsgPanel";
import PasswordRecovery from "../components/Homepage/PasswordRecovery";
import PasswordRecoveryMsgPanel from "../components/Homepage/PasswordRecoveryMsgPanel";
import UsernameRecovery from "../components/Homepage/UsernameRecovery";
import UsernameRecoveryMsgPanel from "../components/Homepage/UsernameRecoveryMsgPanel";

export default {
  components: {
    "login-form": Login,
    "first-login-form": FirstLogin,
    "password-recovery-form": PasswordRecovery,
    "username-recovery-form": UsernameRecovery,
    "new-password-form": NewPassword,
    "login-msg": LoginMsgPanel,
    "first-login-msg": FirstLoginMsgPanel,
    "password-recovery-msg": PasswordRecoveryMsgPanel,
    "username-recovery-msg": UsernameRecoveryMsgPanel,
    "new-password-msg": NewPasswordMsgPanel
  },
  data() {
    return {};
  },
  created() {
    this.$store.commit("error/RESET");
  },
  computed: {
    componentId() {
      let routeName = this.$route.name;
      let compName;
      if (routeName == "login") {
        compName = "login";
      } else if (routeName == "firstLogin") {
        compName = "first-login";
      } else if (routeName == "passwordRecovery") {
        compName = "password-recovery";
      } else if (routeName == "usernameRecovery") {
        compName = "username-recovery";
      } else if (routeName == "newPassword") {
        compName = "new-password";
      }
      return compName;
    }
  },
  methods: {}
};
</script>
<style scoped>
.height-spacer {
  min-height: 100px;
}
.left-content {
  background-image: url("../assets/images/bg_login_left.jpg");
  background-size: cover;
  background-position: center;
}
.right-content {
  background-image: url("../assets/images/fest-cube.png");
  background-color: var(--secondary);
}
</style>
